import { getMaskData } from "@/helpers/apis";
import { Stack } from "@altimateai/lego";
import { Typography } from "@altimateai/lego";
import { useQuery } from '@tanstack/react-query';

const MasksView = () => {
  const { data: maskData } = useQuery({
    queryKey: ["GET-MASK-DATA"],
    queryFn: () => getMaskData(),
  });
  return (
    <Stack direction="column" className="al-space-y-3">
      {maskData?.mask_data?.map(mask => (
        <Stack key={mask.label}>
          <Typography className="al-text-muted-foreground">{mask.label}</Typography>
          <Typography>{mask.masking_type}</Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default MasksView;
